
import TicaOrderchampLogo from '@marketplace/components/shared/icons/TicaOrderchampLogo.vue'

export default {
    name: 'TicaModalTemplate',

    components: {
        TicaOrderchampLogo,
    },

    props: {
        includeLogo: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        bgStyle() {
            let image = require('~assets/images/tica/banner-signup.avif')
            return {
                backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url(${image}) `,
                backgroundPosition: 'top center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: `cover`,
            }
        },
    },
}
